import { PlayDetailSeriesPageModule } from '../types';
import { t } from '@/utils/i18nUtils';

export const FocusKey = {
  PlayDetailErrorPageRetryBtn: 'play-detail-error-page-retry',
  PlayDetailSeriesPageSeasonList: 'play-detail-series-page-season-list',
  PlayDetailSeriesPageRangelist: 'play-detail-series-page-season-item',
  PlayDetailSeriesPageVideoList: 'play-detail-series-page-video-list',
  PlayDetailMainPageMoreBtn: 'play-detail-main-page-more-btn',
  PlayDetailMainPageOptionList: 'play-detail-main-page-option-list',
  PlayDetailMainPageRecommendList: 'play-detail-main-page-recommend-list',
};

const { SeasonList, Rangelist, VideoList } = PlayDetailSeriesPageModule;

export const ModuleToFocusKey = {
  [SeasonList]: FocusKey.PlayDetailSeriesPageSeasonList,
  [Rangelist]: FocusKey.PlayDetailSeriesPageRangelist,
  [VideoList]: FocusKey.PlayDetailSeriesPageVideoList,
};

export const GROUP_SIZE = 20;

export const PlayDetailPageText = {
  more: t('playDetailPage.more'),
  playNow: t('playDetailPage.playNow'),
  containuePlay: t('playDetailPage.containuePlay'),
  episodeAndRelateVideo: t('playDetailPage.episodeAndRelateVideo'),
  recommend: t('playDetailPage.recommend'),

  allText: t('playDetailPage.all'),
  allEpisode: t('playDetailPage.allEpisode'),
  updateToEpisode: t('playDetailPage.updateToEpisode'),

  episodeList: t('playDetailPage.episodeList'),
  relatedEpisodes: t('playDetailPage.relatedEpisodes'),
  episodeNum: t('playDetailPage.episodeNum'),
  episodeNumToNum: t('playDetailPage.episodeNumToNum'),

  episodesNotAvailable: t('playDetailPage.episodesNotAvailable'),
  episodesNotAvailableTip: t('playDetailPage.episodesNotAvailableTip'),
  retry: t('common.retry'),

  trailer: t('playDetailPage.trailer'),
  noVideoList: t('playDetailPage.noVideoList'),
};
